export { RankedTable as RankedCommunitiesTable } from './ranked-table/ranked-table.component';
export { RankedRow as RankedCommunityRow } from './ranked-table/ranked-row.component';
export { Placeholder as LeaderboardPlaceholder } from './placeholder/placeholder.component';

export { Podium as LeaderboardPodium } from './podium/podium.component';
export { Pagination as LeaderboardPagination } from './pagination/pagination.component';

export { Tabs as LeaderboardTabs } from './tabs/tabs.component';
export { TabPanel as LeaderboardTabPanel } from './tabs/tab-panel.component';
